import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';

export default class PurchaseRequestFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.purchaseRequestNumber = '';
		this.partClassificationId = '';
		this.partClassificationCode = '';
		this.vendorId = '';
		this.vendorCode = '';
		this.totalQtyFrom = '';
		this.totalQtyTo = '';
		this.revisi = '';
		this.purchaseOrderNumber = '';
		this.purchaseRequestStatusId = '';
		this.purchaseRequestDateFrom = '';
		this.purchaseRequestDateTo = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			purchaseRequestNumber: '0',
			partClassificationId: '0',
			partClassificationCode: '0',
			vendorId: '0',
			vendorCode: '0',
			totalQtyFrom: '0',
			totalQtyTo: '0',
			revisi: '0',
			purchaseOrderNumber: '0',
			purchaseRequestStatusId: '0',
			purchaseRequestDateFrom: '0',
			purchaseRequestDateTo: '0',
			deliveryDateFrom: '0',
			deliveryDateTo: '0',
			remarkMultiple: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}